export const generateRandomString = (length: number = 32) =>
  Array.from({ length: Math.ceil(length / 8) })
    .map(() => Math.random().toString(36))
    .join('')
    .replace(/0\./g, '')
    .substr(0, length);
